import React, { useEffect, useState } from "react";
import {
    ResponsiveContainer,
    BarChart,
    XAxis,
    YAxis,
    Tooltip,
    Legend,
    Bar,
} from "recharts";
import { useTranslation } from "react-i18next";

export default function ReactiveWeeklyReactiveEnergyChart({ deviceId, API_BASE }) {
    const { t } = useTranslation();
    const [data, setData] = useState([]);
    const formatMax3 = (value) =>
        new Intl.NumberFormat("tr-TR", { maximumFractionDigits: 3 }).format(Number(value || 0));

    useEffect(() => {
        async function load() {
            try {
                const res = await fetch(
                    `${API_BASE}/reactive/daily-reactive-energy-history?deviceId=${deviceId}`
                );
                const json = await res.json();
                let history = json.history || [];

                setData(
                    history.map((d) => ({
                        date: d.day.split("T")[0],
                        dailyEnductive: Number(d.daily_import || 0),
                        dailyCapacitive: Number(d.daily_export || 0),

                    }))
                );
            } catch (err) {
                console.error("ReactiveWeeklyReactiveEnergyChart error:", err);
            }
        }

        load();
    }, [deviceId, API_BASE]);

    return (
        <div className="bg-white border border-slate-200 rounded-xl shadow-sm p-5">
            <h3 className="text-sm font-semibold text-slate-700 mb-3">
                {t('dashboard.weeklyReactiveTitleIC')}
            </h3>

            <div className="h-80">
                <ResponsiveContainer width="100%" height="100%">
                    <BarChart data={data}>
                        <XAxis dataKey="date" stroke="#6B7280" />
                        <YAxis stroke="#6B7280" />
                        <Tooltip formatter={(value, name) => [formatMax3(value), name]} />
                        <Legend />

                        <Bar dataKey="dailyEnductive" name={t('dashboard.legendInductivekVArh')} fill="#3B82F6" />
                        <Bar dataKey="dailyCapacitive" name={t('dashboard.legendCapacitivekVArh')} fill="#EF4444" />
                    </BarChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
}
